import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const MonthRow = styled.div`
    width:100%;
    display:grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
`;

export const CalDay = styled.div`
    display:flex;
    align-items:center;
    justify-content: center;
    font-size: clamp(16px, 1.2vw, 26px);
    font-weight: 500;
    margin-bottom: 20%;
`;

export const Day = styled.div<{typeColor?:number, disable?:boolean}>`
    display:flex;
    align-items:center;
    justify-content: center;
    font-size: clamp(14px, 1vw, 24px);
    width:80%;
    margin-left: auto;
    margin-right: auto;
    aspect-ratio: 1 / 1;
    background:${props => props.typeColor === 1?"#2A848E":props.typeColor === 2?"#FA505E":props.typeColor === 3?"#FED425":props.typeColor === 4?"#FD934F":""};
    border-radius: 100%;
    margin-bottom: 20%;
    color:${props => props.typeColor != 0?"#fff":"#000"};
    font-weight: ${props => props.typeColor != 0?"500":"400"};
    cursor: ${props => props.typeColor != 0?"pointer":"unset"};
    opacity: ${props => props.disable?"0.4":"1"};
`;

export const ListRow = styled.div`
    
`;

export const ListItem = styled.div<{miss?:boolean}>`
    display:flex;
    align-items: center;
    justify-content:  ${props => props.miss?"center":"space-between"};
    border-bottom: ${props => props.miss?"none":"1px solid #B9D4D7"};
    padding:${props => props.miss?"80px 0 0 0":"2px 10px"};
    font-size: ${props => props.miss?"24px":"unset"};
    font-weight: ${props => props.miss?"500":"unset"};
    color: ${props => props.miss?"#202020":"unset"};
`;

export const ItemTime = styled.div<{typeColor?:number}>`
    display:flex;
    flex-direction: column;

    span:nth-of-type(1){
        font-size: 13px;
        font-weight: 500;
    }

    span:nth-of-type(2){
        font-size: 12px;
        color:#A8A8A8;
    }

    b{
        font-weight: 400;
        color:${props => props.typeColor === 1?"#2A848E":props.typeColor === 2?"#FA505E":props.typeColor === 3?"#f0ca32":""};
    }
`;
export const ItemStack = styled.div<{typeColor?:number}>`
    display:flex;
    flex-direction: column;
    align-items: end;

    span:nth-of-type(1){
        font-size: 13px;
        font-weight: 500;
        color:${props => props.typeColor === 1?"#2A848E":props.typeColor === 2?"#FA505E":props.typeColor === 3?"#f0ca32":""};
    }

    span:nth-of-type(2){
        font-size: 12px;
        color:#A8A8A8;
    }
`;


export const LogRow = styled.div`
    display:flex;
    flex-direction: column;
    overflow-y: auto;
    overscroll-behavior: contain;
    height:60%;
`;

export const LogItem = styled.span<{typeColor?:number}>`
    padding:6px 10px;
    border-bottom: 1px solid #d3d3d3;
    
    > div {
        padding-left: 12px;
    }

`;

export const RegType = styled.b<{typeColor?:number}>`
    font-weight: 500;
    color:${props => props.typeColor === 1 ||props.typeColor === -1?"#2A848E":props.typeColor === 2?"#FA505E":props.typeColor === 3?"#f0ca32":""};
    
`;

export const ViewSwitch = styled.div<{hideNextMonth?:boolean}>`
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding:0 10px 20px 10px;

    span{
        font-size: 16px;
        font-weight: 500;
    }
    svg{
        cursor: pointer;
        height:20px;
        width:20px;
        path{
            fill:#000;
        }
    }

    div:nth-of-type(2){
        opacity: ${props => props.hideNextMonth?"0.5":"1"};
        pointer-events: ${props => props.hideNextMonth?"none":"all"};
    }
`;

export const NavRow = styled.div`
    position: absolute;
    bottom:20px;
    left:0;
    display:flex;
    width:100%;
    justify-content: center;
    gap:10%;
`;

export const NavPoint = styled.div<{active?:boolean}>`
    background: ${props => props.active?"#338993":"#ECECEC"};
    width:50px;
    height:34px;
    border-radius: 4px;
    display:flex;
    align-items:center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;


    svg {
        height:64%;
        path{
            fill:  ${props => props.active?"#fff":"#747474"};
        }
    }
`;